export enum CarrierImportVerificationStatus {
  ON_GOING = 'ON_GOING',
  SUCCEED = 'SUCCEED',
  PARTIALLY_SUCCEED = 'PARTIALLY_SUCCEED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED',
}
